export const administrationAccountsRoomDetails = {
    template: require('./administration-accounts-room-details.html'),
    controller: 'AdministrationAccountsRoomDetailsController'
};
